import enLoginMethods from './en.loginMethods.json';

export const loginMethods = {
  en: enLoginMethods,
};
